import { useState, useEffect } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import axios from 'axios';
import getParamsEnv from '../../../utils/getParamsEnv';
import GlobalTable from '../../utils/GlobalTable';
import UsuariosForm from './UsuariosForm';

export default function UsuariosTable() {
    console.log('UsuariosTable Mounted');
    return (
        <Routes>
            <Route index element={<UsuariosList />} />
            <Route path="nuevo" element={<UsuariosForm />} />
            <Route path="editar/:id" element={<UsuariosForm />} />
        </Routes>
    );
}



function UsuariosList() {
    const [usuarios, setUsuarios] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const [error, setError] = useState(null);

    const { API_URL_BASE } = getParamsEnv();
    const API_URL = API_URL_BASE;

    useEffect(() => {
        fetchUsuarios();
    }, []);

    const fetchUsuarios = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await axios.get(`${API_URL}users`, {
                params: { page: 1, limit: 100 },
                headers: { Authorization: `Bearer ${token}` }
            });

            if (response.data && response.data.users) {
                setUsuarios(response.data.users);
            }
        } catch (err) {
            console.error(err);
            setError("Error cargando usuarios: " + (err.response?.data?.message || err.message));
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (user) => {
        if (!window.confirm(`¿Estás seguro de eliminar al usuario ${user.userName}?`)) return;
        try {
            const token = localStorage.getItem("token");
            await axios.delete(`${API_URL}user/${user.userid}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            fetchUsuarios();
        } catch (err) {
            alert("Error eliminando usuario: " + err.message);
        }
    };

    const columns = [
        { header: 'Usuario', accessor: 'userName' },
        { header: 'Nombre', accessor: 'description' },
        { header: 'Email', accessor: 'email' },
        {
            header: 'Rol',
            render: (row) => (
                <span className="px-2 py-1 bg-indigo-100 text-indigo-700 rounded-full text-xs font-semibold">
                    {row.Role?.rolename || row.roleid}
                </span>
            )
        },
        {
            header: 'Plantas',
            render: (row) => (
                <div className="flex flex-wrap gap-1">
                    {row.AccesosPlanta && row.AccesosPlanta.length > 0 ? (
                        row.AccesosPlanta.map((acc, idx) => (
                            <span key={idx} className="px-2 py-0.5 bg-green-50 text-green-700 text-xs rounded border border-green-100">
                                {acc.pathfiltro}
                            </span>
                        ))
                    ) : (
                        <span className="text-gray-400 italic text-xs">Sin acceso</span>
                    )}
                </div>
            )
        },
        {
            header: 'Estado',
            render: (row) => (
                row.userstatus
                    ? <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                        <span className="w-1.5 h-1.5 rounded-full bg-green-600"></span> Activo
                    </span>
                    : <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800">
                        <span className="w-1.5 h-1.5 rounded-full bg-red-600"></span> Inactivo
                    </span>
            )
        }
    ];

    if (error) return <div className="p-4 text-red-500 text-center bg-red-50 rounded-lg">{error}</div>;

    return (
        <div className="flex flex-col h-full w-full">
            <GlobalTable
                storageKey="usuarios_sis"
                columns={columns}
                data={usuarios}
                isLoading={loading}
                onCreate={() => navigate('nuevo')}
                onEdit={(user) => navigate(`editar/${user.userid}`)}
                onDelete={handleDelete}
            />
        </div>
    );
}
